// core
import React from "react";

// components
import LModal from "../../../../common/components/Modals/LModal/LModal";
import ModalHeader from "../../../../common/components/Modals/ModalHeader/ModalHeader";
import styles from "./CustomerServiceModal.module.scss";
import TableContainer from "../../TableList/TableContainer";
import InsurerLogo from "../../../../common/components/InsurerLogo/InsurerLogo";
import { IQuoteCardResult } from "../../../interfaces/results/IQuoteCardResult";
import TableRow from "../../TableList/TableRow/TableRow";
import StarRating from "../../../../common/components/StarRating/StarRating";
import TableCell from "../../TableList/TableCell/TableCell";
import useWindowDimensions from "../../../../common/hooks/useWindowDimensions";
import cx from "classnames";
import TableSection from "../../TableList/TableSection/TableSection";

interface ICustomerServiceModal {
    results: IQuoteCardResult[];
    isOpen: boolean;
    onClose: () => void;
}

const CustomerServiceModal: React.FC<ICustomerServiceModal> = (props) => {
    const { results, isOpen, onClose } = props;

    const { isTabletPortrait } = useWindowDimensions();

    const sortedResults = results
        .filter((val, index, self) => {
            return (
                self.findIndex(
                    (item) => item.result.providerId === val.result.providerId
                ) === index
            );
        })
        .sort(
            (a, b) =>
                b.ratings.customerService.orderBy - a.ratings.customerService.orderBy
        );

    const now = new Date();

    return (
        <React.Fragment>
            <LModal
                Header={() => (
                    <ModalHeader onClose={onClose} title="Customer service rating" />
                )}
                calcHeightMode="auto"
                width="wide"
                isOpen={isOpen}
                onClose={onClose}>
                {() => (
                    <React.Fragment>
                        <div
                            className={cx([styles["customer-other-container"], "gap-l"])}>
                            <h4>How have other Kiwis rated their insurer?</h4>
                            <p>
                                LifeDirect customers rate the customer service of their
                                insurer (for example how long it took the insurer to set
                                up their policy). The results are from our 250 most recent
                                ratings, so they are up to the minute.
                            </p>
                        </div>
                        <div
                            className={cx([styles["customer-rating-container"], "gap-"])}>
                            <TableContainer
                                title="Current Customer Service Ratings*"
                                footnote={`* As at ${now.toLocaleDateString("default", {
                                    year: "numeric",
                                    month: "long",
                                    day: "numeric"
                                })}`}>
                                <TableSection>
                                    {sortedResults.map(
                                        (result): React.ReactElement<typeof TableRow> => {
                                            const key = `${
                                                result.result.providerName
                                            }-${Object.values(result.productInfo)
                                                .map((s) => s.productId)
                                                .join(";")}`;

                                            if (isTabletPortrait) {
                                                return (
                                                    <TableRow key={key}>
                                                        <TableCell className="layout-flex-column">
                                                            <InsurerLogo
                                                                includesAboutInsurerModal
                                                                providerId={
                                                                    result.result
                                                                        .providerId
                                                                }
                                                            />
                                                            <StarRating
                                                                rating={
                                                                    result.ratings
                                                                        .customerService
                                                                        .ratingInfo
                                                                }
                                                                maxRating={5}
                                                            />
                                                        </TableCell>
                                                    </TableRow>
                                                );
                                            }

                                            return (
                                                <TableRow key={key}>
                                                    <TableCell size="medium">
                                                        <InsurerLogo
                                                            includesAboutInsurerModal
                                                            providerId={
                                                                result.result.providerId
                                                            }
                                                        />
                                                    </TableCell>
                                                    <TableCell>
                                                        <StarRating
                                                            rating={
                                                                result.ratings
                                                                    .customerService
                                                                    .ratingInfo
                                                            }
                                                            maxRating={5}
                                                        />
                                                    </TableCell>
                                                </TableRow>
                                            );
                                        }
                                    )}
                                </TableSection>
                            </TableContainer>
                        </div>
                    </React.Fragment>
                )}
            </LModal>
        </React.Fragment>
    );
};

export default CustomerServiceModal;
